import { useMemo, useState } from "react";
import { monthLabel } from "@/lib/productionTable";
import { PHASES, nextStepLabel, situationLabel, summarizeRow, SITUATIONS } from "@/lib/productionSummary";
import "./ProducaoResumo.css";

// Um cartão por ciclo, nas mesmas seis fases da visão por cliente.
export function ProducaoKanban({ clientes = [], ciclos = [], tarefas = [], onOpenCycle, onMove, now }) {
  const [over, setOver] = useState("");
  const columns = useMemo(() => {
    const clientById = new Map(clientes.map((c) => [c.id, c]));
    const cards = ciclos
      .filter((c) => c.status !== "concluido" && c.status !== "cancelado" && !c.arquivado && !c.cliente_encerrado_em && clientById.has(c.cliente_id))
      .map((c) => summarizeRow({
        key: c.id, client: clientById.get(c.cliente_id), cycles: [c], kind: c.competencia ? "recurring" : "project",
        tasks: tarefas.filter((t) => t.ciclo_id === c.id && t.status !== "cancelado" && !t.cliente_encerrado_em),
      }, now))
      .sort((a, b) => SITUATIONS[a.situation].order - SITUATIONS[b.situation].order || a.client.empresa.localeCompare(b.client.empresa, "pt-BR"));
    return PHASES.map((phase, index) => ({ ...phase, cards: cards.filter((card) => card.phase === index) }));
  }, [clientes, ciclos, tarefas, now]);

  const drop = (event, phase) => {
    event.preventDefault();
    setOver("");
    const cycle = ciclos.find((c) => c.id === event.dataTransfer.getData("text/plain"));
    if (cycle && !phase.etapas.includes(cycle.etapa)) onMove?.(cycle, phase.etapas[0]);
  };

  return <div className="kanban" data-testid="production-kanban">
    {columns.map((phase) => <section key={phase.key} className="kanban-column" aria-label={`${phase.label}: ${phase.cards.length}`}>
      <h2><span>{phase.label}</span><small>{phase.cards.length}</small></h2>
      <div className={`kanban-drop ${over === phase.key ? "is-over" : ""}`} data-testid={`kanban-coluna-${phase.key}`}
        onDragOver={(event) => { event.preventDefault(); setOver(phase.key); }}
        onDragLeave={() => setOver((current) => (current === phase.key ? "" : current))}
        onDrop={(event) => drop(event, phase)}>
        {phase.cards.map((card) => {
          const cycle = card.cycles[0];
          return <button type="button" key={card.key} className="kanban-card" draggable data-testid={`kanban-card-${cycle.id}`} data-situation={card.situation}
            onClick={() => onOpenCycle?.(cycle.id)}
            onDragStart={(event) => { event.dataTransfer.setData("text/plain", cycle.id); event.dataTransfer.effectAllowed = "move"; }}
            onDragEnd={() => setOver("")}>
            <span className="summary-name kanban-name">{card.client.empresa}</span>
            <span className="kanban-meta">
              <span className="summary-sub">{cycle.competencia ? monthLabel(cycle.competencia) : cycle.titulo}</span>
              {card.situation !== "em_dia" && <span className={`summary-status is-${card.situation}`}>{situationLabel(card)}</span>}
            </span>
            {card.next && <span className="kanban-next"><span>{card.next.titulo}</span><span className="summary-sub">{nextStepLabel(card.next)}</span></span>}
          </button>;
        })}
        {!phase.cards.length && <p className="kanban-empty">Nenhum ciclo</p>}
      </div>
    </section>)}
  </div>;
}
